import { render, staticRenderFns } from "./EditieArchief.vue?vue&type=template&id=82174810&"
import script from "./EditieArchief.vue?vue&type=script&lang=js&"
export * from "./EditieArchief.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports